var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'「ウォーク/ラン」で計測したデータの一部のみ反映される理由は？'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("\n          管理者はGPSウォーク/ランイベントのペース規則を設定しています。イベント開催期間内、「ウォーク/ラン」機能で記録したスコアのペースとペース規則が一致しないデータは、有効スコアとしてカウントされません。また、一回の運動で1㎞未満の記録もスコアとしてカウントされません。\n        ")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ffd7fdd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help16.vue
// module id = dfzB
// module chunks = 0